import { useEffect, useState } from "react"

import { CdnImage, Icon } from "@trueskin-web/components"
import { arrowRightIcon } from "@trueskin-web/theme/icons/arrowRightIcon"
import { shineIcon } from "@trueskin-web/theme/icons/shineIcon"

const PlanDetails = ({
  isSelected,
  title,
  image,
  detailsTitle,
  details,
  description,
  isSubscription,
  footnote,
  className,
}) => {
  const [isExpanded, setIsExpanded] = useState(false)

  const handleClick = () => {
    setIsExpanded((v) => !v)
  }

  useEffect(() => {
    setIsExpanded(isSelected)
  }, [isSelected])

  return (
    <>
      {!isSubscription ? (
        <div
          sx={{
            mt: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {description}

          <Icon
            icon={arrowRightIcon}
            onClick={handleClick}
            sx={{
              mt: 1,
              transform: isExpanded ? "rotate(-90deg)" : "rotate(90deg)",
              transition: "transform 0.25s linear",
            }}
          />
        </div>
      ) : null}

      <div
        sx={{
          maxHeight: isExpanded ? "500px" : 0,
          overflow: "hidden",
          transition: "max-height 0.4s linear",
        }}
        className={className}
      >
        {image ? (
          <CdnImage
            src={image}
            alt={title}
            data-testid="web-portal-plan-selection-plan-block-image"
            sx={{
              my: 3,
              width: "100%",
              borderRadius: "4px",
            }}
          />
        ) : null}

        {detailsTitle && (
          <div
            sx={{
              mb: 3,
              fontSize: 3,
              fontFamily: "display",
              lineHeight: "smallerHeading",
            }}
          >
            {detailsTitle}
          </div>
        )}

        <div
          sx={{
            mt: 2,
            display: "flex",
            flexDirection: "column",
            rowGap: 4,
            lineHeight: "smallerHeading",
          }}
        >
          {details.map((item, index) => (
            <div
              key={index}
              sx={{
                display: "inline-flex",
                columnGap: 1,
                fontSize: isSubscription ? 0 : 1,
              }}
              data-component-name="web-portal-plan-selection-plan-details"
            >
              {!!item.icon ? (
                <Icon
                  icon={item.icon}
                  size="sm"
                  color={item.theme}
                  sx={{
                    mt: "2px",
                    flexShrink: 0,
                    transform: "scale(1.125)",
                  }}
                />
              ) : (
                <span> &bull;</span>
              )}

              {item.content}
            </div>
          ))}
        </div>

        {footnote ? (
          <div
            sx={{
              mt: 4,
              py: 2,
              px: 3,
              display: "flex",
              gap: 2,
              background: "lightBlue",
              borderRadius: "8px",
              fontSize: 1,
              color: "#0B1770",
            }}
          >
            <Icon icon={shineIcon} size="sm" />
            {footnote}
          </div>
        ) : null}
      </div>
    </>
  )
}

export default PlanDetails
